import { usePendingCount } from '../../hooks/usePendingPhotos'

// Persistent fixed-position pill shown whenever there are photos
// waiting to upload. Mounted once at the App root so it's visible on
// every screen. Phase 1: informational only — Phase 2 will let users
// tap it to see queue status / retry failures.
export function UploadIndicator() {
  const count = usePendingCount()
  if (count === 0) return null

  return (
    <div
      // Top, offset to the right of where the typical back/X button sits
      // (~16px from left + ~32px wide + gap). pointer-events-none so the
      // pill never intercepts taps. safe-area-aware so it clears the iOS
      // status bar / notch.
      className="fixed top-5 left-16 z-50 pointer-events-none flex items-center gap-2 bg-white/95 backdrop-blur border border-gray-200 rounded-full shadow-md px-3 py-1.5"
      style={{ marginTop: 'env(safe-area-inset-top, 0px)' }}
      role="status"
      aria-live="polite"
    >
      <div className="w-3.5 h-3.5 border-2 border-gray-300 border-t-gray-900 rounded-full animate-spin" />
      <span className="text-xs font-medium text-gray-700">
        {count === 1 ? 'Uploading photo' : `Uploading ${count} photos`}
      </span>
    </div>
  )
}
